import { render, staticRenderFns } from "./FooterSocial.vue?vue&type=template&id=5bc743bb&"
import script from "./FooterSocial.vue?vue&type=script&lang=js&"
export * from "./FooterSocial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports